import { createSingleTicketsQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useSingleTicketsQuery = createSingleTicketsQuery(HTTP_CONFIG.API.Consumer.url)
